
import { AfterViewInit, Component, ElementRef, Inject, OnInit, PLATFORM_ID, Renderer2, ViewChild } from '@angular/core';
import * as AOS from 'aos';
import Swiper from 'swiper';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ThankYouPopupComponent } from '../../common/thank-you-popup/thank-you-popup.component'; // Import the ThankYouPopupComponent
import { Constants } from '../../common/constants';
import { Title, Meta } from '@angular/platform-browser';
import { DOCUMENT, isPlatformBrowser, ViewportScroller } from '@angular/common';
import { SeoService } from 'src/app/common/seo.service';
import { IntlTelInputComponent } from 'src/app/shared/intl-tel-input/intl-tel-input.component';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { NgxIntlTelInputComponent } from 'ngx-intl-tel-input';
import { Country } from 'ngx-intl-tel-input/lib/model/country.model';



@Component({
  selector: 'app-internship',
  templateUrl: './internship.component.html',
  styleUrls: ['./internship.component.css']
})
export class InternshipComponent implements OnInit {
  // @ViewChild('phoneInput') phoneInput!: NgxIntlTelInputComponent;

  form!: FormGroup;
  isSubmitting: boolean = false;
  thankYouVisible: boolean = true;
  dialogRef!: MatDialogRef<ThankYouPopupComponent>;
  selectedFile!: File;
  baseurl = Constants.baseUrl;
  isBrowser: boolean = false;
  baseUrl = Constants.baseUrl;
  loading = false;
  phoneNumber: string = '+91';
  selectedCountryCode: string = '';
  isInvalid: boolean = false;
  errorMessage: string = '';
  phoneErrorMessage: string = '';
  profileName: string = '';
  @ViewChild('swiperContainer', { static: false }) swiperContainer!: ElementRef;

  private setTitleAndMetaTags(): void {
    this.titleService.setTitle('Graduates IT Training and Development | Sparkminds');

    this.metaService.addTags([
      { name: 'description', content: 'Accelerate your career with Sparkminds Training and Development Programme. It helps you Accelerate, Connect and Experience certainty with your internship with us.' },
      { property: 'og:type', content: 'website' },
      { property: 'og:title', content: 'Graduates IT Training and Development | Sparkminds' },
      { property: 'og:url', content: 'https://mitresource.com/internship/' },
      { property: 'og:image', content: 'https://mitresource.com/assets/images/InternshipPage/Hands-On-Learning.png' },
      { property: 'og:description', content: 'Accelerate your career with Sparkminds Training and Development Programme. It helps you Accelerate, Connect and Experience certainty with your internship with us.' },
    ]);
  }


  constructor(private fb: FormBuilder, private http: HttpClient, private dialog: MatDialog, private titleService: Title, private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document, private seoService: SeoService,
    private metaService: Meta, private renderer: Renderer2, private viewportScroller: ViewportScroller, @Inject(PLATFORM_ID) private platformId: any,
  ) { this.isBrowser = isPlatformBrowser(this.platformId); }

  ngOnInit() {
    let script = this._renderer2.createElement('script');
    script.type = `application/ld+json`;
    script.text = `
{
  "@context": "https://schema.org",
  "@type": "Article",
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": "https://mitresource.com/internship/"
  },
  "headline": "Graduates IT Training and Development | Sparkminds",
  "description": "Accelerate your career with Sparkminds Training and Development Programme. It helps you Accelerate, Connect and Experience certainty with your internship with us.",
  "image": "https://mitresource.com/assets/images/InternshipPage/Hands-On-Learning.png",  
  "author": {
    "@type": "Organization",
    "name": "Maganti IT",
    "url": "https://mitresource.com"
  },  
  "publisher": {
    "@type": "Organization",
    "name": "Maganti IT",
    "logo": {
      "@type": "ImageObject",
      "url": "https://mitresource.com/assets/images/homepage/update-mitimage.png"
    }
  },
  "datePublished": "2024-06-28"
}`;

    this._renderer2.appendChild(this._document.head, script);
    this.setTitleAndMetaTags();
    this.seoService.createLinkForCanonicalURL();

    if (this.isBrowser) { AOS.init({ disable: 'mobile', duration: 2000, delay: 500, once: true }); AOS.refresh(); }


    // this.form = this.fb.group({
    //   Name: ['', [Validators.required, this.customNameValidator()]],
    //   College: ['', [Validators.required, this.customNameValidator()]],
    //   Qualification: ['', [Validators.required, Validators.pattern(/^[a-zA-Z ]*$/)]],
    //   Email: ['', [Validators.required, this.customEmailValidator()]],
    //   Phone: ['', [Validators.required, this.customPhoneValidator()]],
    //   selectInterstedProgram: ['Sparkminds', Validators.required],
    //   attachment: [null, Validators.required],

    // });

    this.form = this.fb.group({
      Name: ['', [Validators.required, Validators.maxLength(30), Validators.minLength(2), Validators.pattern(/^[a-zA-Z]{3,}([ ]?[a-zA-Z]+)*$/)]],
      // College: [''],
      Qualification: ['', [Validators.required, this.customQualificationValidator()]],
      Email: ['', [Validators.required, this.customEmailValidator()]],
      Phone: ['', [Validators.required, this.customPhoneValidator()]],
      selectInterstedProgram: ['Sparkminds Orientation', Validators.required],
      attachment: [null],
    });


  }



  swiperBreakpoints = {
    320: { slidesPerView: 1 },
    768: { slidesPerView: 2 },
    1024: { slidesPerView: 2 }
  };

  // onFileChanged(event: any) {
  //   const file = event.target.files[0];
  //   this.selectedFile = file;
  //   this.form.patchValue({
  //     attachment: file
  //   });
  //   this.form.get('attachment')!.updateValueAndValidity();
  // }
  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    this.profileName = '';
    if (input.files && input.files.length > 0) {
      this.selectedFile = input.files[0];
      this.profileName = this.selectedFile.name;
      this.form.get('attachment')!.updateValueAndValidity();

    }
  }
  resetFileInput() {
    this.form.get('attachment')?.reset();
    const fileInput = document.querySelector('input[type="file"]') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
  }
  // onFileChanged(event: any) {
  //   const file = event.target.files[0];  // Get the selected file
  //   this.selectedFile = file;
  //   this.form.patchValue({ attachment: file });

  //   this.form.get('attachment')!.updateValueAndValidity();  // Still allow validation to happen if needed
  // }
  onSubmit(): void {
    if (this.form.invalid) {
      this.loading = true;
      this.form.markAllAsTouched();
      return;
    }
    if (this.form.valid) {
      this.loading = true;
      this.isSubmitting = true;
      const uploadData = new FormData();
      uploadData.append('Name', this.form.get('Name')!.value);
      uploadData.append('College', "college");
      uploadData.append('Qualification', this.form.get('Qualification')!.value);
      uploadData.append('Email', this.form.get('Email')!.value);
      uploadData.append('Phone', this.phoneNumber);
      uploadData.append('selectInterstedProgram', this.form.get('selectInterstedProgram')!.value);
      if (this.selectedFile) {
        uploadData.append('attachment', this.selectedFile, this.selectedFile.name);
      } else {
        uploadData.append('attachment', "null");
      }
      this.http.post(this.baseurl + '/api/Customers/sendSparkDetails', uploadData)
        .subscribe(
          () => {
          },
          error => {
            console.error('Email sending failed', error);
            this.loading = false;
            this.isSubmitting = false;
          }
        );
      this.http.post(this.baseurl + '/api/Customers/submitFormData', uploadData)
        .subscribe(
          (response: any) => {
            this.loading = false;
            this.isSubmitting = false;
            this.form.reset();
            this.phoneNumber = '+91';
            this.profileName = '';
            this.resetFileInput();
            this.dialogRef = this.dialog.open(ThankYouPopupComponent, {
              data: {
                title: 'Thank You for Sharing Your Info!',
                message: 'Our executives will contact you shortly to discuss how we can assist you further.'
              }
            });
            setTimeout(() => {
              this.thankYouVisible = false;
              this.dialog.closeAll();
            }, 5000);
          },
          error => {
            // console.error('Form saving failed', error);
            this.loading = false;
            this.isSubmitting = false;
          }
        );
    } else {
      this.form.markAllAsTouched();
    }
  }

  isFormControlInvalid(controlName: string): boolean {
    const control = this.form.get(controlName);
    return control ? control.invalid && (control.dirty || control.touched) : false;
  }

  getErrorMessage(controlName: string): string {
    const control = this.form.get(controlName);
    if (controlName === 'attachment') {
      return this.isFormControlInvalid(controlName) ? 'Please choose a file.' : '';
    }
    if (control?.hasError('required')) {
      return `${controlName.replace('input', '')} is required.`;
    } else if (control?.hasError('emptyName')) {
      return 'Name cannot be empty.';
    } else if (control?.hasError('invalidName')) {
      return 'Name allows only alphabets.';
    } else if (control?.hasError('emptyEmail')) {
      return 'Email is required.';
    } else if (control?.hasError('invalidEmail')) {
      return 'Enter a valid business email.';
    } else if (control?.hasError('emptyPhone')) {
      return 'Phone number is required.';
    } else if (control?.hasError('invalidPhone')) {
      return 'Enter a valid phone number.';
    } else if (control?.hasError('invalidPattern')) {
      return 'Invalid phone number for selected country.';
    } else if (control?.hasError('emptyQualification')) {
      return ' Qualification is required.';
    } else if (control?.hasError('invalidQualification')) {
      return ' Qualification allows alphabets, spaces, (.), (-)';
    } else if (control?.hasError('pattern')) {
      return 'Only letters and spaces are allowed';
    } else if (control?.hasError('minlength')) {
      return 'Minimum 2 characters required';
    } else if (control?.hasError('maxlength')) {
      return 'Maximum 30 characters allowed';
    } else {
      return '';
    }
  }

  // Custom validator for the name input
  customNameValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return { emptyName: true };
      }
      // Allow alphabets, numbers, spaces, hyphens, apostrophes, and dots
      if (!/^[A-Za-z0-9\s\-'.]+$/.test(control.value)) {
        return { invalidName: true };
      }
      return null;
    };
  }


  // Custom validator for email input
  customEmailValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return { emptyEmail: true };
      }
      if (!/^[a-zA-Z][\w\-_.]*[a-zA-Z0-9]@[a-zA-Z]+\.[a-zA-Z]{2,3}$/.test(control.value)) {
        return { invalidEmail: true };
      }
      return null;
    };
  }
  customQualificationValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;

      if (!value) {
        return { emptyQualification: true }; // Qualification field is empty
      }

      const regex = /^[a-zA-Z .-]*$/;
      if (!regex.test(value)) {
        return { invalidQualification: true }; // Qualification contains invalid characters
      }

      return null; // No errors
    };
  }
  // Custom validator for phone number input
  customPhoneValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const phone = this.phoneNumber;
      if (!phone || phone.trim() === '') {
        return { emptyPhone: true }; // Phone number is empty
      }
      const parsedPhone = parsePhoneNumberFromString(phone);
      if (!parsedPhone || !parsedPhone.isValid()) {
        return { invalidPattern: true };
      }
      return null;
    };
  }
  scrollToSection(sectionId: string) {
    this.viewportScroller.scrollToAnchor(sectionId);
    if (this.isBrowser) {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }



  ngAfterViewInit() {
    if (this.isBrowser) {
      const swiperElement = this.swiperContainer.nativeElement;
      const shadowRoot = swiperElement.shadowRoot;

      if (shadowRoot) {
        const paginationElement = shadowRoot.querySelector('.swiper-pagination');
        if (paginationElement) {
          // Apply styles to the pagination bullets        
          this.renderer.setStyle(paginationElement, 'position', 'unset');
        } else {
          // console.error('Pagination element not found in shadow root');
        }
      } else {
        // console.error('Shadow root not found');
      }

    }
  }

  onPhoneInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.value.length > 13) {
      input.value = input.value.slice(0, 13); // Trim to 13 characters
      this.form.get('contactPhone')?.setValue(input.value);
    }
  }

  onPhoneNumberChange(phone: any) {
    this.phoneNumber = phone; // Update the phone number
    this.isInvalid = false;

    if (!this.phoneNumber) {
      this.isInvalid = true;
      this.phoneErrorMessage = "Phone number is required.";
      return;
    }
    this.form.get('Phone')?.setValue(event); // Set value in form control
    this.form.get('Phone')?.updateValueAndValidity();
    const phoneNumber = parsePhoneNumberFromString(this.phoneNumber);
    if (this.phoneNumber) {
      if (phoneNumber && phoneNumber.isValid()) {
        this.isInvalid = false;
        this.errorMessage = '';
      } else {
        this.isInvalid = true;
        this.phoneErrorMessage = 'Invalid phone number for selected country';
      }
    } else {
      this.isInvalid = true;
      this.phoneErrorMessage = 'Phone number is required';
    }
  }
  getPhoneErrorMessage() {
    return this.errorMessage;
  }

}